// Lazy loader for Fabric.js 6.0
import { 
  Canvas, 
  FabricObject,
  Path,
  Rect,
  Circle,
  Ellipse,
  Line,
  Group,
  FabricImage,
  FabricText,
  Shadow,
  util,
  Point
} from 'fabric';

// Configure FabricObject defaults
FabricObject.prototype.transparentCorners = false;
FabricObject.prototype.cornerColor = '#007AFF';
FabricObject.prototype.cornerSize = 8;
FabricObject.prototype.cornerStyle = 'circle';
FabricObject.prototype.borderColor = '#007AFF';
FabricObject.prototype.borderScaleFactor = 2;

// Disable cache for better performance on mobile and to prevent render errors
FabricObject.prototype.objectCaching = false;
// statefullCache is deprecated in Fabric.js 6.0
// FabricObject.prototype.statefullCache = false;
FabricObject.prototype.noScaleCache = true;

// Disable caching for images specifically
if (typeof FabricImage !== 'undefined') {
  FabricImage.prototype.objectCaching = false;
  // statefullCache is deprecated in Fabric.js 6.0
  // FabricImage.prototype.statefullCache = false;
  FabricImage.prototype.noScaleCache = true;
}

// Set selection colors (removed deprecated properties)
// Selection styling is now handled through Canvas properties

// Export all classes and utilities
export { 
  Canvas, 
  FabricObject,
  Path,
  Rect,
  Circle,
  Ellipse,
  Line,
  Group,
  FabricImage,
  FabricText,
  Shadow,
  util,
  Point
};

// Create a fabric namespace for backward compatibility
export const fabric = {
  Canvas,
  Object: FabricObject,
  Path,
  Rect,
  Circle,
  Ellipse,
  Line,
  Group,
  Image: FabricImage,
  Text: FabricText,
  Shadow,
  util,
  Point,
  FabricImage // Add both for compatibility
};

let fabricPromise: Promise<typeof import('fabric')> | null = null;

export async function loadFabric() {
  if (!fabricPromise) {
    fabricPromise = import('fabric');
  }
  return fabricPromise;
}

// Preload Fabric.js when user hovers over whiteboard link
export function preloadFabric() {
  if (!fabricPromise) {
    loadFabric();
  }
}